import { vsprintf } from 'printj';
import { sha256 } from 'js-sha256';
import { Base64 } from 'js-base64';
import router from '../router';
import { Address } from './models';

// export async function loginUser(user: Login): Promise<User> {
//   clearJWT();
//   const response = await axios.post('/api/v2/service/authentication/login', {
//     username: user.username,
//     password: user.password,
//   });
//   setJWT(response.headers['x-auth-token'], response.headers['x-refresh-token'], response.headers['x-csrf-token']);
//   return (response.data as User);
// }

export function routerGoto(addr: string) {
  router.push(addr);
}

export function versionStr(r: number, f: number) {
  return `${r ? r : 0}.${f ? f : 0}`;
}

export function transportStr(tr: number): string {
  switch (tr) {
    case 1:
      return 'WiFi';
    case 2:
      return 'GSM';
    default:
      // console.log(`Unknown tranport: ${tr}`);
      return 'unknown';
  }
}

export function simInstalledStr(si: boolean): string {
  if (si) {
    return 'Установлена';
  }
  return 'Не установлена';
}

export function secsToStr(seconds: number): string {
  const days: number = Math.floor(seconds / 3600 / 24);
  let remainder: number = seconds - days * 3600 * 24;
  const hours: number = Math.floor(remainder / 3600);
  remainder = remainder - hours * 3600;
  const mins: number = Math.floor(remainder / 60);
  remainder = remainder - mins * 60;
  const secs: number = remainder;

  let secsStr: string = '';
  let minsStr: string = '';
  let hoursStr: string = '';
  let daysStr: string = '';

  if (secs !== 0) {
    secsStr = vsprintf('%02d сек.', [secs]);
  }
  if (mins !== 0) {
    minsStr = vsprintf('%02d мин.', [mins]);
  }
  if (hours !== 0) {
    hoursStr = vsprintf('%02d час.', [hours]);
  }
  if (days !== 0) {
    daysStr = vsprintf('%d дн.', [days]);
  }

  return vsprintf('%s %s %s %s', [daysStr, hoursStr, minsStr, secsStr]);
}

export function counterValueStr(value: number): string {
  return vsprintf('%d.%03d', [value / 1000, value % 1000]);
}

export function dateStr(date: string): string {
  const today = new Date(date);
  return today.toLocaleString('RU');
}

export function passwordToHash(username: string, password: string): string {
  const hash = username + '-*-' + password;
  return Base64.encode(sha256(hash)).slice(0, -2);
}

export function addressStr(addr: Address): string {
  let building = '';
  if (addr.building && addr.building.length > 0) {
    building = `/${addr.building}`;
  }
  return `${addr.city}, ${addr.street}, ${addr.house}${building}, ${addr.flat}`;
}

export function controllerEventTypeIdToString(id: string): string {
  switch (id) {
    case   '4': return 'Принудительная синхронизация с сервером.';
    case   '5': return 'Высокая температура в помещении!';
    case   '6': return 'Температура снова в допустимом диапазоне.';
    case   '7': return 'Низкая температура в помещении!';
    case   '8': return 'Температура снова в допустимом диапазоне.';
    case   '9': return 'Датчик протечки активирован.';
    case  '10': return 'Протечка!';
    case  '11': return 'Протечка закончилась.';
    case  '12': return 'Датчик протечки отключён.';
    case  '28': return 'Обнаружен расход воды в "Сухой период"!';
    case '100': return 'Показания переданы на портал Госуслуги Москвы!';
    case '101': return 'Внутренняя ошибка при передаче показаний на портал Госуслуги Москвы! Обратитесь в службу поддержки.';
    case '102': return 'Ошибка при передаче показаний на портал Госуслуги Москвы! Проверьте корректность регистрации на портале.';
    case '103': return 'Невозможно внести показание, поскольку не введены показания за три и более месяца, предшествующих текущему. Для возобновления удалённой передачи показаний Вам следует обратиться в Центр госуслуг/ГКУ ИС района.';
    case '105': return 'Вносимое показание меньше предыдущего. Проверьте корректность вносимого показания. В случае, если передаваемые данные корректны, Вам следует обратиться в Центр госуслуг/ГКУ ИС района для уточнения причин ошибки.';
    case '106': return 'Показание за данный период уже внесено.';
    case '107': return 'Не допускается внесение данных, в несколько раз превышающих нормативы водопотребления, установленные Правительством Москвы.';
    case '109': return 'Невозможно внести показание, поскольку уже внесено показание на более позднюю дату.';
    case '110': return 'Показания отправлены на e-mail.';
    case '111': return 'Внутренняя ошибка при отправке на e-mail! Обратитесь в службу поддержки.';
    case '112': return 'Показания отправлены в управляющую компанию.';
    case '113': return 'Не удалось отправить показания в управляющую компанию.';
    case '114': return 'Контроллер пропустил запланированный выход на связь.';
    case '115': return 'Контроллер не соединился с сервером после установки.';
    case '116': return 'Контроллер перезагрузился несколько раз за короткий период';
    case '117': return 'Один из счетчиков передал одинаковые показания несколько раз подряд';
    case '118': return 'Вносимое показание меньше поверочного. Проверьте правильность ввода передаваемого показания. В случае, если передаваемые данные корректны, Вам следует обратиться в Центр госуслуг/ГКУ ИС района для уточнения причин ошибки.';
    case '119': return 'Невозможно внести показание, поскольку потребление должно быть не меньше 0.001 куб.м. либо равно 0.';
    case '120': return 'Истек срок поверки прибора учета. Обратитесь в Вашу управляющую организацию с документом о выполненной поверке.';
    case '121': return 'Ввод показаний на дату позже даты очередной поверки заблокирован. Обратитесь в Вашу управляющую организацию с документом о выполненной поверке.';
    case '122': return 'Ошибка поверки прибора учета. Обратитесь в Центр госуслуг/ГКУ ИС района.';
    case '123': return 'Ввод показаний заблокирован. Не указана дата очередной поверки прибора учета. Обратитесь в Центр госуслуг/ГКУ ИС района.';
    case '124': return 'Указанный идентификатор организации в реестре не найден (организация не зарегистрирована)';
    default:  return `Неизвестное событие (${id})`;
  }
}

export function controllerEventTypeIdToColorClass(id: string): string {
  switch (id) {
    case   '5': // 'Высокая температура в помещении!';
    case   '7': // 'Низкая температура в помещении!';
    case  '10': // 'Протечка!';
    case '114': // 'Контроллер пропустил запланированный выход на связь.';
    case '115': // 'Контроллер не соединился с сервером после установки.'
    case '101': return 'red--text'; // 'Внутренняя ошибка при передаче показаний на портал Госуслуги Москвы! Обратитесь в службу поддержки.';
    case   '4': // 'Принудительная синхронизация с сервером.';
    case   '6': // 'Температура снова в допустимом диапазоне.';
    case   '8': // 'Температура снова в допустимом диапазоне.';
    case   '9': // 'Датчик протечки активирован.';
    case '100': // 'Показания переданы на портал Госуслуги Москвы!';
    case '110': // 'Показания отправлены на e-mail.';
    case '112': return 'green--text'; // 'Показания отправлены в управляющую компанию.';
    case  '11': // 'Протечка закончилась.';
    case  '12': // 'Датчик протечки отключён.';
    case  '28': // 'Обнаружен расход воды в "Сухой период"!';
    case '102': // 'Ошибка при передаче показаний на портал Госуслуги Москвы! Проверьте корректность регистрации на портале.';
    case '103': // 'Невозможно внести показание, поскольку не введены показания за три и более месяца, предшествующих текущему. Для возобновления удалённой передачи показаний Вам следует обратиться в Центр госуслуг/ГКУ ИС района.';
    case '105': // 'Вносимое показание меньше предыдущего. Проверьте корректность вносимого показания. В случае, если передаваемые данные корректны, Вам следует обратиться в Центр госуслуг/ГКУ ИС района для уточнения причин ошибки.';
    case '106': // 'Показание за данный период уже внесено.';
    case '107': // 'Не допускается внесение данных, в несколько раз превышающих нормативы водопотребления, установленные Правительством Москвы.';
    case '109': // 'Невозможно внести показание, поскольку уже внесено показание на более позднюю дату.';
    case '111': // 'Внутренняя ошибка при отправке на e-mail! Обратитесь в службу поддержки.';
    case '113': // 'Не удалось отправить показания в управляющую компанию.';
    case '116': // 'Контроллер перезагрузился несколько раз за короткий период';
    case '117': // 'Один из счетчиков передал одинаковые показания несколько раз подряд';
    case '118': // 'Вносимое показание меньше поверочного. Проверьте правильность ввода передаваемого показания. В случае, если передаваемые данные корректны, Вам следует обратиться в Центр госуслуг/ГКУ ИС района для уточнения причин ошибки.';
    case '119': // 'Невозможно внести показание, поскольку потребление должно быть не меньше 0.001 куб.м. либо равно 0.';
    case '120': // 'Истек срок поверки прибора учета. Обратитесь в Вашу управляющую организацию с документом о выполненной поверке.';
    case '121': // 'Ввод показаний на дату позже даты очередной поверки заблокирован. Обратитесь в Вашу управляющую организацию с документом о выполненной поверке.';
    case '122': // 'Ошибка поверки прибора учета. Обратитесь в Центр госуслуг/ГКУ ИС района.';
    case '123': // 'Ввод показаний заблокирован. Не указана дата очередной поверки прибора учета. Обратитесь в Центр госуслуг/ГКУ ИС района.';
    case '124': // 'Указанный идентификатор организации в реестре не найден (организация не зарегистрирована)';
    default:  return 'orange--text'; // `Неизвестное событие (${id})`;
  }
}

function _formatDatetime(date: Date, format: string) {
  const padStart = (value: number): string => value.toString().padStart(2, '0');
  return format
    .replace(/yyyy/g, padStart(date.getFullYear()))
    .replace(/dd/g, padStart(date.getDate()))
    .replace(/mm/g, padStart(date.getMonth() + 1))
    .replace(/hh/g, padStart(date.getHours()))
    .replace(/ii/g, padStart(date.getMinutes()))
    .replace(/ss/g, padStart(date.getSeconds()));
}

function isValidDate(d: Date): boolean {
  return !isNaN(d.getTime());
}

export function formatDate(date: any, format: string): string {
  const datetime = new Date(date);
  return isValidDate(datetime) ? _formatDatetime(datetime, format /* 'yyyy-mm-dd hh:ii:ss' */) : '';
}
